import React from 'react';
import { FileText, BadgeCheck, Banknote, LineChart, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ScrollReveal } from './ScrollReveal';
import './how-it-works.css';

const steps = [
  {
    num: '01',
    icon: FileText,
    title: 'Submit your request',
    desc: 'Fill out a secure online form with your loan amount and basic details.',
    accent: '#319595',
  },
  {
    num: '02',
    icon: BadgeCheck,
    title: 'Fast approval',
    desc: 'Our team reviews your application quickly with clear eligibility checks.',
    accent: '#00b4d8',
  },
  {
    num: '03',
    icon: Banknote,
    title: 'Funds transferred',
    desc: 'Approved amount is disbursed directly to your bank account without delays.',
    accent: '#134074',
  },
  {
    num: '04',
    icon: LineChart,
    title: 'Track & manage',
    desc: 'Monitor repayments, schedules, and support — all in one place.',
    accent: '#e8c547',
  },
];

const HowItWorks = () => {
  return (
    <section className="hiw-section" aria-labelledby="hiw-title">
      <div className="hiw-hero-bg" aria-hidden="true">
        <div className="hiw-orb hiw-orb--cyan" />
        <div className="hiw-orb hiw-orb--navy" />
        <div className="hiw-dots" />
      </div>

      <div className="hiw-container">
        <ScrollReveal className="hiw-head" y={24}>
          <span className="hiw-eyebrow">Simple process</span>
          <h2 id="hiw-title" className="hiw-title">
            How it works
          </h2>
          <p className="hiw-sub">
            From application to disbursement — four clear steps, fully digital.
          </p>
        </ScrollReveal>

        <ScrollReveal className="hiw-track-wrap" y={32} delay={0.06}>
          <ol className="hiw-track">
            {steps.map(({ num, icon: Icon, title, desc, accent }) => (
              <li key={num} className="hiw-step">
                <span className="hiw-marker" style={{ '--hiw-accent': accent }}>
                  {num}
                </span>
                <div className="hiw-step-head">
                  <span className="hiw-icon" style={{ '--hiw-accent': accent }}>
                    <Icon size={20} strokeWidth={2.2} aria-hidden />
                  </span>
                  <h3>{title}</h3>
                </div>
                <p>{desc}</p>
              </li>
            ))}
          </ol>
        </ScrollReveal>

        <ScrollReveal className="hiw-foot" y={20} delay={0.1}>
          <p>Ready to get started?</p>
          <Link to="/apply-now" className="hiw-cta">
            Apply now
            <ArrowRight size={16} aria-hidden />
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default HowItWorks;
